// store/modules/title.js
export default {
  namespaced: true, // 开启命名空间
  state: {
    title: '学院专利数量统计',
    title2: '',
    title3: ''
  },
  mutations: {
    setTitle(state, newTitle) {
      if (typeof newTitle === 'object') {
        state[newTitle.key] = newTitle.value
      } else {
        state.title = newTitle
      }
      // state.title = newTitle
    }
  },
  actions: {
    updateTitle({ commit }, newTitle) {
      // 可以在这里做异步操作，比如从接口获取标题
      commit('setTitle', newTitle)
    }
  },
  getters: {
    getTitle: state => state.title
  }
}
